export default function PHP_fmod() {
  return (
    <div>
      <h1>PHP_fmod</h1>
    </div>
  );
}
